import React from 'react';
import { graphql } from 'gatsby';

import { ComingUp } from '../sections/coming-up/coming-up';
import { About } from '../sections/about/about';
import { Calendar } from '../sections/calendar/calendar';
import { Player } from '../sections/player/player';
import { TileGrid } from '../sections/tile-grid';
import { PageHeader } from '../sections/page-header';

export default class Page extends React.Component {
  get page () {
    return this.props.data.contentfulPage;
  }

  componentDidMount () {
    console.log(this.page);
  }

  sectionMapper = (section) => {
    switch (section.__typename) {
      case "ContentfulSectionComingUpBlock": return <ComingUp {...section} />;
      case "ContentfulSectionAbout": return <About {...section} />;
      case "ContentfulSectionCalendar": return <Calendar {...section} />;
      case "ContentfulSectionMainVideoPlayer": return <Player {...section} />;
      case "ContentfulSectionIntroHeader": return <PageHeader {...section} />;
      case "ContentfulSectionTileGrid": return <TileGrid {...section} />;
    }
  }

  render = () => (
    <>
      { this.page.sections && this.page.sections.map(section => this.sectionMapper(section)) }
    </>
  );
}


export const query = graphql`
  query PageQuery($slug: String!) {
    contentfulPage(slug: { eq: $slug }) {
      sections {
        ... on ContentfulSectionAbout {
          __typename
        }
        ... on ContentfulSectionCalendar {
          __typename
          title
        }
        ... on ContentfulSectionComingUpBlock {
          __typename
          title
        }
        ... on ContentfulSectionMainVideoPlayer {
          __typename
          title
        }
        ... on ContentfulSectionIntroHeader {
          __typename
          title
          content {
            raw
          }
        }
        ... on ContentfulSectionTileGrid {
          __typename
          title
          automatedTileGrid
          selectedItems {
            ... on ContentfulShow {
              __typename
              slug
              name
              when
              excerpt {
                excerpt
              }
              photo {
                file {
                  url
                }
              }
            }
            ... on ContentfulLabel {
              __typename
              slug
              name
              when
              excerpt {
                excerpt
              }
              photo {
                file {
                  url
                }
              }
            }
            ... on ContentfulArtist {
              __typename
              slug
              name
              when
              excerpt {
                excerpt
              }
              photo {
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`